var map = {
	"./about/about-controller.js": "./_pages/about/about-controller.js",
	"./about/press-information/press-information-controller.js": "./_pages/about/press-information/press-information-controller.js",
	"./collaborate/collaborate-controller.js": "./_pages/collaborate/collaborate-controller.js",
	"./design-resources/design-resources-controller.js": "./_pages/design-resources/design-resources-controller.js",
	"./design/design-controller.js": "./_pages/design/design-controller.js",
	"./downloads/downloads-controller.js": "./_pages/downloads/downloads-controller.js",
	"./handoff/handoff-controller.js": "./_pages/handoff/handoff-controller.js",
	"./home/home-controller.js": "./_pages/home/home-controller.js",
	"./icons/icons-controller.js": "./_pages/icons/icons-controller.js",
	"./license/license_controller.js": "./_pages/license/license_controller.js",
	"./newsletter/feedback/form-controller.js": "./_pages/newsletter/feedback/form-controller.js",
	"./pricing/pricing-controller.js": "./_pages/pricing/pricing-controller.js",
	"./prototype/prototype-controller.js": "./_pages/prototype/prototype-controller.js",
	"./releases/releases-controller.js": "./_pages/releases/releases-controller.js",
	"./store/edu/form/form-controller.js": "./_pages/store/edu/form/form-controller.js",
	"./store/edu/user-info/user-info-controller.js": "./_pages/store/edu/user-info/user-info-controller.js",
	"./store/edu/workspace/workspace-controller.js": "./_pages/store/edu/workspace/workspace-controller.js",
	"./store/payment-complete_controller.js": "./_pages/store/payment-complete_controller.js",
	"./store/store_controller.js": "./_pages/store/store_controller.js",
	"./support/contact/form-controller.js": "./_pages/support/contact/form-controller.js",
	"./updates/updates-controller.js": "./_pages/updates/updates-controller.js",
	"./vs/vs-controller.js": "./_pages/vs/vs-controller.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./_pages sync recursive [_-]controller\\.js$";